import { TableCell, TableRow } from 'semantic-ui-react';
import { Stack, Tray } from '@phosphor-icons/react';
import { Link } from 'react-router-dom';
import { ColoredPill, ColorText, MuteText, StyledButton } from '../../elements';
import { PackingStatus } from './common';
import { DateFormat, DateUtility, theme } from '../../utility';

function PackingTime({ time, isEnabled }) {
  let timeColor = '';
  const noOfDays = DateUtility.noOfDays(time);
  if (isEnabled) {
    if (noOfDays < 1) {
      timeColor = theme.colors.green;
    } else if (noOfDays <= 2) {
      timeColor = theme.colors.yellow;
    } else if (noOfDays <= 5) {
      timeColor = theme.colors.orange;
    } else if (noOfDays > 5) {
      timeColor = theme.colors.danger;
    }
  }
  return (
    <ColorText color={timeColor}>
      <b>{DateUtility.hourMinuteTime(time)}</b>
    </ColorText>
  );
}

export function PackagingListRow({ item }) {
  return (
    <TableRow>
      <TableCell>{item?.wave?.waveNumber}</TableCell>
      <TableCell>
        <PackingStatus status={item?.status} />
      </TableCell>
      <TableCell>
        <PackingTime time={item.updatedAt} isEnabled />
        <div>
          <MuteText>
            {DateUtility.formatDate(item.updatedAt, DateFormat.barChartMonth)}
          </MuteText>
        </div>
      </TableCell>
      <TableCell>
        {item?.palletNumber ? (
          <ColoredPill>
            <Stack />
            {item?.palletNumber}
          </ColoredPill>
        ) : (
          <ColoredPill>
            <Tray />
            {item?.toteNumber}
          </ColoredPill>
        )}
      </TableCell>
      <TableCell>{item?.contents?.length}</TableCell>
      <TableCell collapsing>
        <Link
          to={`/app/fulfill/packing/details/${
            item.palletNumber || item?.toteNumber
          }/?warehouseId=${item.warehouse._id}`}
        >
          <StyledButton>Start Packing</StyledButton>
        </Link>
      </TableCell>
    </TableRow>
  );
}
